/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190902 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';
import { ActivityTypesDaoService } from '../activity-types-dao.service';
import { ActivityType } from 'src/app/_model/activity-type';

// CONSTANTS
const ACTIVITYTYPES_KEY = 'activity-types';

@Injectable()
export class ActivityTypesStorageDaoService implements ActivityTypesDaoService {
  constructor(private keyValueStorage: KeyValuePersistenceService) {}

  public saveActivityTypes(activityTypes: ActivityType[]): Promise<void> {
    return this.keyValueStorage.store(ACTIVITYTYPES_KEY, activityTypes);
  }
  public getActivityTypes(): Promise<ActivityType[]> {
    return this.keyValueStorage.load(ACTIVITYTYPES_KEY);
  }

  public async reset() {}

  public async clear() {
    await this.keyValueStorage.delete(ACTIVITYTYPES_KEY);
  }
}
